"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripTypeTitle = exports.tripTypeShortDescription = exports.tripTypeDriverTitle = exports.tripTypePriority = exports.tripTypeNonRideshare = exports.tripTypePremium = exports.tripTypeRideshare = exports.tripTypeDeserialize = exports.tripTypeAllKnown = void 0;
const sentenceCase_1 = __importDefault(require("../util/sentenceCase"));
const stringEnumDeserialize_1 = __importDefault(require("./stringEnumDeserialize"));
exports.tripTypeAllKnown = [
    'butler',
    'delivery',
    'heli',
    'LUX',
    'nanny',
    'POSH',
    'runner',
    'scoopM',
    'scoopXl',
    'SUV',
    'taxi',
];
exports.tripTypeDeserialize = (0, stringEnumDeserialize_1.default)(exports.tripTypeAllKnown, 'trip type', false);
exports.tripTypeRideshare = ['scoopM', 'scoopXl', 'butler', 'nanny', 'LUX', 'SUV', 'POSH'];
exports.tripTypePremium = ['SUV', 'POSH', 'LUX'];
exports.tripTypeNonRideshare = exports.tripTypeAllKnown.filter(type => !exports.tripTypeRideshare.includes(type));
function tripTypePriority(type) {
    return exports.tripTypeAllKnown.indexOf(type);
}
exports.tripTypePriority = tripTypePriority;
function tripTypeDriverTitle(type) {
    switch (type) {
        case 'scoopM':
        case 'scoopXl':
        case 'SUV':
        case 'LUX':
        case 'POSH':
            return 'Rideshare';
        case 'delivery':
            return 'Delivery';
        case 'runner':
            return 'Task';
        case 'butler':
            return 'Butler Service';
        case 'nanny':
            return 'KidsRides';
        case 'taxi':
            return 'Taxi';
        case 'heli':
            return 'Wave Heli';
        case 'UNKNOWN':
            return (0, sentenceCase_1.default)(type);
    }
}
exports.tripTypeDriverTitle = tripTypeDriverTitle;
function tripTypeShortDescription(type) {
    switch (type) {
        case 'scoopM':
            return 'Standard (awesome) service';
        case 'scoopXl':
            return 'For groups of up to 6';
        case 'delivery':
            return 'Delivery services';
        case 'runner':
            return 'Our runners will get the job done';
        case 'butler':
            return 'Tailored to the needs of older riders';
        case 'nanny':
            return 'For kids, with certified safe drivers';
        case 'taxi':
            return 'Hail a local taxi';
        case 'SUV':
            return 'A premium service';
        case 'LUX':
            return 'High-end fleet';
        case 'POSH':
            return 'Exotic vehicles';
        case 'heli':
            return 'Travel via helicopter';
        case 'UNKNOWN':
            return 'Ride with Wave';
    }
}
exports.tripTypeShortDescription = tripTypeShortDescription;
function tripTypeTitle(type) {
    switch (type) {
        case 'scoopM':
            return 'Wave';
        case 'scoopXl':
            return 'WaveXL';
        case 'delivery':
            return 'Delivery';
        case 'runner':
            return 'Task';
        case 'butler':
            return 'Butler Service';
        case 'nanny':
            return 'KidsRides';
        case 'taxi':
            return 'Taxi';
        case 'SUV':
            return 'Black car SUV';
        case 'LUX':
            return 'Wave LUX';
        case 'POSH':
            return 'Wave Posh';
        case 'heli':
            return 'Wave Heli';
        case 'UNKNOWN':
            return (0, sentenceCase_1.default)(type);
    }
}
exports.tripTypeTitle = tripTypeTitle;
